import 'css-chunksrc/client/pages/zonePage/wbsPage/heading/zone/styles.scss';export default {
  "project": "_project_25bxy_1",
  "main": "_main_25bxy_6",
  "icon": "_icon_25bxy_16",
  "wrapper": "_wrapper_25bxy_23",
  "row": "_row_25bxy_33",
  "name": "_name_25bxy_42",
  "menu": "_menu_25bxy_52",
  "open": "_open_25bxy_60",
  "toggleArrow": "_toggleArrow_25bxy_63",
  "buttons": "_buttons_25bxy_67"
};